import { AssetType } from "lib/types/assets/AssetType";
import { AssetCategory } from "lib/types/assets/AssetCategory";
import { drawingFileExtensions } from "lib/actions/files";

export function categorizeAsset(type: AssetType, ext?: string): AssetCategory {
  switch (type) {
    case "model":
      return drawingFileExtensions.has(ext)
        ? AssetCategory.cad
        : AssetCategory.bim;
    case "pointCloud":
      return AssetCategory.pointcloud;
    case "scanSet":
    case "scanset":
      return AssetCategory.scanset;
    case "layer":
      return AssetCategory.layer;
    case "gisSimpleFeature":
      return AssetCategory.gis;
    case "rasterImagery":
    case "rasterTerrain":
      return AssetCategory.raster;
    default:
      return ext != null ? getFileExtensionCategory(ext) : AssetCategory.other;
  }
}

/**
 * Whether an asset falls within a category group, where `groupFilter` is a
 * bitmask of one or more {@link AssetCategory} values.
 */
export function isInAssetGroup(
  type: AssetType,
  ext: string | undefined,
  groupFilter: AssetCategory,
): boolean {
  return (categorizeAsset(type, ext) & groupFilter) > 0;
}

function getFileExtensionCategory(ext: string): AssetCategory {
  return extensionMap[ext]?.categories ?? AssetCategory.other;
}

const extensionMap: { [key: string]: { categories: AssetCategory } } = {
  ifc: { categories: AssetCategory.bim },
  nwd: { categories: AssetCategory.bim },
  nwf: { categories: AssetCategory.bim },
  "12da": { categories: AssetCategory.bim },
  obj: { categories: AssetCategory.bim },
  fbx: { categories: AssetCategory.bim },

  e57: { categories: AssetCategory.pointcloud },
  las: { categories: AssetCategory.pointcloud },
  laz: { categories: AssetCategory.pointcloud },
  ply: { categories: AssetCategory.pointcloud },
  pts: { categories: AssetCategory.pointcloud },

  geojson: { categories: AssetCategory.gis },
  topojson: { categories: AssetCategory.gis },
  gpkg: { categories: AssetCategory.gis },
  kml: { categories: AssetCategory.gis },
  kmz: { categories: AssetCategory.gis },
  gml: { categories: AssetCategory.gis },
  shp: { categories: AssetCategory.gis },
  shx: { categories: AssetCategory.gis },
  dbf: { categories: AssetCategory.gis },
  prj: { categories: AssetCategory.gis },

  dsm: { categories: AssetCategory.raster },
  tiff: { categories: AssetCategory.raster },
  tif: { categories: AssetCategory.raster },

  jpg: { categories: AssetCategory.image },
  jpeg: { categories: AssetCategory.image },
  png: { categories: AssetCategory.image },

  pdf: { categories: AssetCategory.pdf },

  dwg: { categories: AssetCategory.cad },
  dxf: { categories: AssetCategory.cad },

  zip: { categories: AssetCategory.zip },

  rvt: { categories: AssetCategory.autodesk },
  idw: { categories: AssetCategory.autodesk },
  iam: { categories: AssetCategory.autodesk },
  rcp: { categories: AssetCategory.autodesk },
  rcs: { categories: AssetCategory.autodesk },

  lgs: { categories: AssetCategory.other },
  docx: { categories: AssetCategory.other },
  doc: { categories: AssetCategory.other },
  csv: { categories: AssetCategory.other },
  ppt: { categories: AssetCategory.other },
  pptx: { categories: AssetCategory.other },
  mp4: { categories: AssetCategory.other },
};
